import Vue from 'vue';
import { docPages } from '@/DocPages';

export default Vue.component('docAppBar', {
    data: () => ({
        helpPages: docPages
    }),
});
